module.exports = {
          srcSet: __webpack_public_path__ + "5341b808928e6581cae9650464b1feec-79.png"+" 79w",
          images:[ {path: __webpack_public_path__ + "5341b808928e6581cae9650464b1feec-79.png",width: 79,height: 79}],
          src: __webpack_public_path__ + "5341b808928e6581cae9650464b1feec-79.png",
          toString:function(){return __webpack_public_path__ + "5341b808928e6581cae9650464b1feec-79.png"},
          
          width: 79,
          height: 79
        }